module.exports = __webpack_public_path__ + "f646b365ae5b0ca35dceacdebc38adb3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/frog.svg
// module id = F57R
// module chunks = 0